import Axios from 'axios'
import {menuUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_menus (context) {
    Axios.get(menuUrls.getAllMenus).then(function (response) {
      context.commit('GET_ALL_MENUS', response.data)
    })
  },
  get_menus (context, publicId) {
    Axios.get(menuUrls.getMenus + publicId).then(function (response) {
      context.commit('GET_MENUS', response.data)
    })
  },
  get_deleted_menus (context) {
    Axios.get(menuUrls.getDeletedMenu).then(function (response) {
      context.commit('GET_DELETED_MENUS', response.data)
    })
  },
  get_menu (context, publicId) {
    Axios.get(menuUrls.getMenu + publicId).then(function (response) {
      context.commit('GET_MENU', response.data)
    })
  },
  post_menu (context, data) {
    Axios.post(menuUrls.postMenu, data).then(function () {
      context.dispatch('get_all_menus')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_menu (context, data) {
    Axios.post(menuUrls.editMenu, data).then(function () {
      context.dispatch('get_all_menus')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_menu (context, publicId) {
    Axios.get(menuUrls.deleteMenu + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_MENUS', response.data)
      router.push({
        name: 'Module.DeletedMenus'
      })
    })
  },
  restoreMenu (context, publicId) {
    Axios.get(menuUrls.restoreMenu + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_MENUS', response.data)
      router.push({
        name: 'Module.Menus'
      })
    })
  }
}
